import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageProvider';
type StoryChapterProps = {
  id: string;
  number: string;
  title: string;
  children: React.ReactNode;
};
export function StoryChapter({
  id,
  number,
  title,
  children
}: StoryChapterProps) {
  const {
    t
  } = useLanguage();
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="scroll-mt-28 border-t border-ink/15 py-10 first:border-t-0" aria-labelledby={`${id}-title`} data-id="element-122" data-mp="1ebj59dhfm4xb">
      <p className="font-sans text-[11px] font-bold uppercase tracking-[0.3em] text-accent" data-id="element-123" data-mp="21zj6j7cdddq5">
        {t.chapterLabel} {number}
      </p>
      <h2 id={`${id}-title`} className="mt-2 font-serif text-3xl font-black tracking-tight sm:text-4xl" data-id="element-124" data-mp="7n2qjetrul83">
        {title}
      </h2>
      <div className="mt-5 space-y-4 text-[17px] leading-[1.75] text-ink/90" data-id="element-125" data-mp="2qccsy5fw1pu">{children}</div>
    </motion.section>;
}